import {useKeycloak} from '@react-keycloak/web';

const AuthGuard = ({children}) => {
    const {keycloak, initialized} = useKeycloak();

    if (!initialized || !keycloak.authenticated) {
        return null;
    }

    return children;
};

export default AuthGuard;